import { render } from "./DiscountCampaignList.vue?vue&type=template&id=3079771c"
import script from "./DiscountCampaignList.vue?vue&type=script&lang=js"
export * from "./DiscountCampaignList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__